<template>
  <div id="cite" :class="toggleClass">用途地域：「
    <a href="https://www.mlit.go.jp/toshi/tosiko/toshi_tosiko_tk_000087.html"
       target="_blank"
       rel="noopener noreferrer">
      都市計画決定GISデータ
    </a>
    」のデータを加工して作成
  </div>
</template>


<script>
export default {
  name      : 'Cite',
  components: {},
  props     : {
    isMyMarkerListOpen: {
      type   : Boolean,
      default: false,
    }
  },
  computed  : {
    toggleClass() {
      return this.isMyMarkerListOpen ? "cite-overlay list-opened" : "cite-overlay list-closed";
    }
  }
}
</script>

<style lang="scss">

.cite-overlay {
  position: absolute;
  bottom: 30px;
  background: rgba(255,255,255,0.8);
  font-size: 0.8rem;
  z-index: 99;
}

.list-opened {
  right: 380px;
}

.list-closed {
  right: 80px;
}
</style>
